module.exports = __webpack_public_path__ + "img/search-shadow.ac9f117e.png";